import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
export default function Research(_ref) {
  var data = _ref.data,
      location = _ref.location;
  var publications = data.publications.edges.map(function (each) {
    return each.node;
  });
  var presentations = data.presentations.edges.map(function (each) {
    return each.node;
  });
  var translations = data.translations.edges.map(function (each) {
    return each.node;
  });
  var publicationList = /*#__PURE__*/React.createElement(React.Fragment, null, publications.map(function (pub) {
    return /*#__PURE__*/React.createElement("div", {
      key: pub.frontmatter.title,
      className: "my-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "citation"
    }, /*#__PURE__*/React.createElement("a", {
      href: pub.frontmatter.link
    }, pub.frontmatter.title), ",", ' ', /*#__PURE__*/React.createElement("span", {
      className: "italic"
    }, pub.frontmatter.venue, "."), ' ', pub.frontmatter.year, "."), /*#__PURE__*/React.createElement("p", {
      className: "mt-2"
    }, pub.frontmatter.abstract));
  }));
  var presentationList = /*#__PURE__*/React.createElement(React.Fragment, null, presentations.map(function (pres) {
    return /*#__PURE__*/React.createElement("div", {
      key: pres.frontmatter.title,
      className: "my-6 citation"
    }, pres.frontmatter.role && pres.frontmatter.role + ', ', "\u201C", pres.frontmatter.title, ".\u201D", ' ', /*#__PURE__*/React.createElement("span", {
      className: "italic"
    }, pres.frontmatter.occasion, ","), ' ', pres.frontmatter.location, ", ", pres.frontmatter.month, ' ', pres.frontmatter.year, ".");
  }));
  var translationList = /*#__PURE__*/React.createElement(React.Fragment, null, translations.map(function (trans) {
    return /*#__PURE__*/React.createElement("div", {
      key: trans.frontmatter.title,
      className: "my-6 citation"
    }, trans.frontmatter.link ? /*#__PURE__*/React.createElement("a", {
      href: trans.frontmatter.link
    }, "pres.frontmatter.author") : trans.frontmatter.author, ', ', "\u201C", trans.frontmatter.title, ".\u201D", ' ', /*#__PURE__*/React.createElement("span", {
      className: "italic"
    }, trans.frontmatter.venue, ","), ' ', trans.frontmatter.year, ".");
  }));
  return /*#__PURE__*/React.createElement(Layout, {
    location: location,
    title: "Home",
    width: "w-11/12 md:w-10/12 lg:w-9/12 xl:w-7/12 2xl:w-1/2"
  }, /*#__PURE__*/React.createElement(SEO, {
    title: "Research Experience"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "text-center text-3xl lg:text-4xl my-10"
  }, "Research"), /*#__PURE__*/React.createElement("h2", {
    className: " mt-8 text-center text-xl font-semibold text-ocean-600"
  }, "Publications"), publicationList, /*#__PURE__*/React.createElement("h2", {
    className: " mt-8 text-center text-xl font-semibold text-ocean-600"
  }, "Translations"), translationList, /*#__PURE__*/React.createElement("h2", {
    className: "mt-8 text-center text-xl font-semibold text-ocean-600"
  }, "Presentations"), presentationList, /*#__PURE__*/React.createElement("h2", {
    className: "mt-8 mb-6 text-center text-xl font-semibold text-ocean-600"
  }, "Projects and Collaborations"), /*#__PURE__*/React.createElement("h3", null, "Global Cinema in Context, 2018 - Present"), /*#__PURE__*/React.createElement("p", {
    className: "mt-4 mb-6"
  }, "Global Cinema in Context is an interdisciplinary project at the University of Illinois to develop digital tools for the study of global cinema. I've been contributing to the project since 2018, contributing expert knowledge on Indian cinema, building web apps for data entry and display, and helping guide the project."), /*#__PURE__*/React.createElement("h3", null, "Gandhari Dictionary Project, 2009 - 2010"), /*#__PURE__*/React.createElement("p", {
    className: "mt-4 mb-6"
  }, "As an undergraduate, I contributed to the Gandhari Dictionary project, led by Stefan Baums. I helped digitize images and cross-reference Gandhari words with Sanskrit sources."), /*#__PURE__*/React.createElement("h2", {
    className: "mt-8 text-center text-xl font-semibold text-ocean-600"
  }, "Education"), /*#__PURE__*/React.createElement("p", {
    className: "my-6 citation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-cerise-800"
  }, "PhD"), " in Comparative Literature, May 2018, University of Illinois at Urbana-Champaign. Dissertation: Translingual Nostalgias in Modern Sanskrit and Indian Poetry in English. Co-Directors: Wa\xEFl Hassan and Rajeshwari Pandharipande. Committee Members: Rini Mehta and Michael Rothberg (UCLA)."), /*#__PURE__*/React.createElement("p", {
    className: "my-6 citation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-cerise-800"
  }, "MA"), " in Comparative Literature (with Distinction), 2012, University of Illinois at Urbana-Champaign."), /*#__PURE__*/React.createElement("p", {
    className: "my-6 citation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-cerise-800"
  }, "BA"), " in English Literature and South Asian Languages & Literatures (Double Degree, Magna Cum Laude), 2009, University of Washington."));
}
var pageQuery = "2313303628";